import styled from 'styled-components';

export const NewsletterAdditionalInfo = styled.div`
    font-size: 0.75em;
    line-height: 1.2;
    padding-top: 14px;
`;
